import { z } from 'zod';
import { baseComponentSchema } from '../component-base.schemas';

// Promo Banner custom colors schema
export const promoBannerCustomColorsSchema = z
  .object({
    background: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid hex color')
      .optional(),
    text: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid hex color')
      .optional(),
    linkText: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid hex color')
      .optional(),
    dismissButton: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid hex color')
      .optional(),
  })
  .optional();

// Promo Banner data schema
export const promoBannerDataSchema = z.object({
  text: z.string().min(1, 'Banner text is required').max(200, 'Banner text too long'),
  linkText: z.string().max(50, 'Link text too long').optional(),
  linkUrl: z.string().optional(),
  linkTarget: z.enum(['_self', '_blank']).default('_self').optional(),
  dismissible: z.boolean().default(true).optional(),
  position: z.enum(['inline']).default('inline').optional(),
  customColors: promoBannerCustomColorsSchema,
});

// Promo Banner component schema
export const promoBannerComponentSchema = baseComponentSchema.extend({
  type: z.literal('promo-banner'),
  data: promoBannerDataSchema,
});

// Type exports
export type PromoBannerCustomColors = z.infer<typeof promoBannerCustomColorsSchema>;
export type PromoBannerData = z.infer<typeof promoBannerDataSchema>;
export type PromoBannerComponent = z.infer<typeof promoBannerComponentSchema>;
